var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChartMo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0398 24C5.40096 24 0 18.5995 0 11.9612C0 5.84931 4.57569 0.710383 10.6449 0.00884851C11.0093 -0.0387595 11.3662 0.108442 11.6026 0.385335C11.8401 0.662774 11.9227 1.03981 11.8248 1.39112C11.6037 2.17912 11.4926 2.97422 11.4926 3.75292C11.4926 8.58048 15.4208 12.5084 20.2488 12.5084C21.0292 12.5084 21.8233 12.3968 22.6097 12.1763C22.9605 12.0783 23.3387 12.1615 23.6156 12.3973C23.8936 12.6343 24.0348 12.9932 23.9927 13.3555C23.2911 19.4242 18.1522 24 12.0398 24ZM9.38068 2.47954C5.18917 3.64621 2.18906 7.4844 2.18906 11.9612C2.18906 17.3923 6.60768 21.8111 12.0398 21.8111C16.517 21.8111 20.355 18.8107 21.5218 14.6196C21.0965 14.6716 20.6708 14.6973 20.2488 14.6973C14.2136 14.6973 9.30351 9.78764 9.30351 3.75292C9.30351 3.33046 9.32923 2.90528 9.38068 2.47954Z",
    fill: "#85BBFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChartMo);
export default __webpack_public_path__ + "static/media/chart_mo.039d9c434b023cd4b6157b3a850e943c.svg";
export { ForwardRef as ReactComponent };